// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__21-vw","signatureBlock":"Footer_signatureBlock__1yfDi","signature":"Footer_signature__24C4L"};